import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Typography,
  Card,
  CardContent,
  Box,
  Select,
  InputAdornment,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  getDescriptionByDomainName,
  parseXmlString,
  xmlToJson,
} from "../../../utils/utils";
import ScreenLoader from "../../common/ScreenLoader";
import BackdropLoader from "../../common/BackdropLoader";
import CustomPopup from "../../common/Modal";
import { get, post } from "../../../services/apiService";
import i18next from "i18next";



const domainOptions = ["com", "co", "net", "org", "site"];

const DomainSearchSection = ({ screenWidth, onRegisterDomain }) => {
  const [selectedDomain, setSelectedDomain] = useState(domainOptions[0]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isBackDropLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [domainError, setDomainError] = useState("");
  const [modalPayload, setModalPayload] = useState({});
  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  const handleSearch = async () => {
    if (searchQuery && selectedDomain) {
      const domain = searchQuery + "." + selectedDomain;
      //check if  domain is available
      setIsLoading(true);
      try {
        const response = await post(
          "users/domain/search",
          { domain: domain },
          {},
          onLoading
        );
        if (response.status === 201) {
          const xml = response.data;
          const xmlDoc = parseXmlString(xml);
          const object = xmlToJson(xmlDoc);
          const isAvailable =
            object.ApiResponse.CommandResponse.DomainCheckResult["@attributes"]
              .Available;
          const domain =
            object.ApiResponse.CommandResponse.DomainCheckResult["@attributes"]
              .Domain;
          if (isAvailable === "true") {
            setDomainError("");
            const response = await get(
              `users/domain/price?domain=${selectedDomain}`,
              {},
              onLoading
            );

            const xml = response.data;
            const xmlDoc = parseXmlString(xml);
            const object = xmlToJson(xmlDoc);
            const domainName =
              object.ApiResponse.CommandResponse.UserGetPricingResult
                .ProductType.ProductCategory.Product["@attributes"].Name;
            const domain =
              object.ApiResponse.CommandResponse.UserGetPricingResult
                .ProductType.ProductCategory.Product.Price[0]["@attributes"];
                console.log('domain info------------->', domain);
            const domainObject = {
              domain: searchQuery + "." + domainName,
              description: i18next.t(getDescriptionByDomainName(domainName)),
              isAvailbility: true,
              currency: domain.Currency,
              originalPrice: domain.Price,
              additionalCost: domain.AdditionalCost,
              regularPrice:domain.RegularPrice,
              regularAdditionalCost:domain.RegularAdditionalCost,
              durationType: domain.DurationType,
              duration: domain.Duration,
            };
            setModalPayload(domainObject);
            setIsModalOpen(true);
          } else {
            setIsLoading(false);
            setDomainError(`${domain} is not available`);
          }
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
    if (searchQuery.length === 0) {
      setDomainError("");
    }
  };

  const handleClose = () => {
    setIsLoading(false);
    setIsModalOpen(false);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#3173B1",
        borderRadius: "16px",
        height: "432px",
        padding: "5%",
        textAlign: "center",
        color: "white",
        fontFamily: "Tajawal-Bold",
      }}
    >
      {isBackDropLoading && <BackdropLoader />}
      {isModalOpen && (
        <CustomPopup
          open={isModalOpen}
          onClose={handleClose}
          query={searchQuery}
          onRegisterDomain={onRegisterDomain}
          buttonText={"Register"}
          heading={"Domain Availability"}
          payload={modalPayload}
        />
      )}
      <Typography
        sx={{
          fontSize: screenWidth > 800 ? "64px" : "48px",
          fontFamily: "Tajawal-Bold",
        }}
      >
        {i18next.t("Find the perfect domain name")}
      </Typography>
      <Typography
        sx={{ fontSize: "16px", fontFamily: "Tajawal-Light", color: "#E6E6E6" }}
      >
        {i18next.t("Enter your select domain name and choose any extension name in the next step")}
      </Typography>

      <Box
        sx={{ display: "flex", justifyContent: "center", marginTop: "62px" }}
      >
        {/* TextField for search input */}
        <TextField
          variant="outlined"
          placeholder= {i18next.t("Search your domain name e.g stackoverflow")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{
            width: screenWidth > 1000 ? "50%" : "90%",

            backgroundColor: "white",
            borderRadius: "8px",
            height: "64px",
            "& .MuiOutlinedInput-root": {
              paddingRight: "0",
              height: "64px",
              paddingTop: "8px",
              paddingBottom: "8px",
            },
            marginRight: "8px",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment
                position="end"
                sx={{ display: "flex", alignItems: "center" }}
              >
                {/* Select Dropdown */}
                {screenWidth > 800 && (
                  <Box sx={{ height: "64px" }}>
                    <Select
                      value={selectedDomain}
                      onChange={(e) => setSelectedDomain(e.target.value)}
                      displayEmpty
                      sx={{
                        backgroundColor: "white",
                        borderRadius: "8px",
                        borderRight: "1px solid #E0E0E0",
                        width: "144px",
                        height: "44px",
                        marginRight: "8px",
                        // marginTop: "10px",
                        color: "#808080",
                        padding: "0 16px",
                        "& .MuiOutlinedInput-root": {
                          padding: "0 8px",
                          height: "44px", // Ensure the input root matches height
                        },
                        "& .MuiSelect-select": {
                          display: "flex",
                          alignItems: "center",
                          height: "100%",
                          padding: "0",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#E0E0E0",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#808080",
                        },
                      }}
                      inputProps={{
                        style: { padding: "0", fontSize: "12px" },
                      }}
                    >
                      {domainOptions.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                )}

                {/* Search Button */}
                <Button
                  onClick={handleSearch}
                  variant="contained"
                  disabled={!searchQuery && !selectedDomain}
                  sx={{
                    backgroundColor: "#3173B1",
                    color: "white",
                    height: "48px",
                    padding: "0 16px",
                    marginRight: "10px",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#02599C",
                    },
                  }}
                >
                  {i18next.t("Search")}
                </Button>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {domainError && (
        <Typography
          sx={{
            marginTop: "1.5%",
            fontSize: "18px",
            color: "#ce2d0e",
            fontFamily: "Tajawal-Regular",
          }}
        >
          {domainError}
        </Typography>
      )}
    </Box>
  );
};

const DomainCard = ({
  domainName,
  description,
  price,
  durationType,
  additionalCost,
  active,
  priceCurr,
  regularPrice,
  regularAdditionalCost,
}) => {
  const isArabic = i18next.language === 'ar';
  return (
    <Card
      sx={{
        backgroundColor: active ? "white" : "#f5f5f5",
        borderRadius: "8px",
        boxShadow: active ? "0px 48px 64px 0px #33333326" : "none",
        padding: "24px",
        textAlign:  !isArabic ? "left" :"right",
        cursor: "pointer",
        width: "95%",
      }}
    >
      {domainName && (
        <CardContent>
          <Typography
            sx={{
              fontSize: "32px",
              fontFamily: "Tajawal-Bold",
              color: "#3173B1",
              fontWeight: 700,
              // textAlign: isArabic && 'center',
            }}
          >
            {domainName?.toUpperCase()}
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              fontFamily: "Tajawal-Regular",
              color: "#808080",
            }}
          >
            {i18next.t(description)}
          </Typography>
          <Typography
            sx={{
              fontSize: "40px",
              color: "#2E2E2E",
              fontWeight: 700,
              fontFamily: "Tajawal-Bold",
            }}
          >
              {(
                (Number(price) || 0) +
                (Number(additionalCost) || 0)
              ).toFixed(2)}{" "}
              {priceCurr} /{" "}
            <span style={{ fontSize: "20px", fontWeight: 400 }}>
              {durationType}
            </span>
            </Typography>

            <Typography
            sx={{
              fontSize: "14px",
              color: "#2E2E2E",
              fontWeight: 400,
              fontFamily: "Tajawal-Regular", 
            }}
          > {i18next.t("Renews at")} {" "}
              {(
                (Number(regularPrice) || 0) +
                (Number(regularAdditionalCost) || 0)
              ).toFixed(2)}{" "}
              { priceCurr} / {" "}
            <span style={{   fontSize: "14px",
              color: "#2E2E2E",
              fontWeight: 400,
              fontFamily: "Tajawal-Bold",
           }}>
              {durationType}  {" "} ({i18next.t("After first Year")})
            </span>
          </Typography>
        </CardContent>
      )}
    </Card>
  );
};

const PopularDomainsSection = ({ screenWidth, onRegisterDomain, domains }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Box sx={{ padding: "64px 0", backgroundColor: "#F7FAFE" }}>
      <Typography
        sx={{
          fontSize: screenWidth > 800 ? "64px" : "48px",
          fontFamily: "Tajawal-Bold",
          color: "#2E2E2E",
          textAlign: "center",
          marginBottom: "32px",
        }}
      >
        {i18next.t("The Most Popular Domain Names are The Best for You")}
      </Typography>

      <Grid
        container
        rowSpacing={2}
        columnSpacing={1}
        sx={{
          paddingLeft: screenWidth > 800 ? "8%" : "5%",
          paddingRight: screenWidth > 800 ? "8%" : "0%",
        }}
      >
        {domains.map((domain, index) => (
          <Grid
            key={index}
            size={{ xl: 3, lg: 4, md: 6, sm: 6, xs: 12 }}
            onClick={() => setActiveIndex(index)}
          >
            <DomainCard
              domainName={domain.domain}
              price={domain.originalPrice}
              durationType={domain.durationType}
              regularPrice={domain.regularPrice}
              regularAdditionalCost={domain.regularAdditionalCost}
              description={domain.description}
              priceCurr={domain.currency}
              additionalCost={domain.additionalCost}
              active={activeIndex === index}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const Domain = ({ screenWidth, onRegisterDomain }) => {
    const [domains, setDomains] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onLoading = (isLoading) => {
    setIsLoading(isLoading);
  };

  useEffect(() => {
    const getAllDomains = async () => {
      const results = [];
      const responses = await get("users/domain/all", {}, onLoading);
      if (responses.data.length > 0) {
        responses?.data?.forEach((response, index) => {
          const xml = response;
          const xmlDoc = parseXmlString(xml);
          const object = xmlToJson(xmlDoc);
          const domainName =
            object?.ApiResponse?.CommandResponse?.UserGetPricingResult
              ?.ProductType.ProductCategory.Product["@attributes"].Name;
          const domain =
            object?.ApiResponse?.CommandResponse?.UserGetPricingResult
              ?.ProductType?.ProductCategory?.Product?.Price[0]["@attributes"];
          const domainObject = {
            domain: domainName,
            description: getDescriptionByDomainName(domainName),
            currency: domain?.Currency,
            originalPrice: domain?.Price,
            additionalCost: domain?.AdditionalCost,
            regularPrice: domain.RegularPrice,
            regularAdditionalCost: domain.RegularAdditionalCost,
            durationType: domain?.DurationType,
            duration: domain?.Duration,
          };
          results.push(domainObject);
        });
        setDomains(results);
      }
    };

    getAllDomains();
  }, []);

  return (
    <>
      <Box sx={{ padding: "6%" }}>
        <DomainSearchSection
          screenWidth={screenWidth}
          onRegisterDomain={onRegisterDomain}
        />
      </Box>
      {isLoading ? (
        <ScreenLoader />
      ) : domains.length > 0 ? (
        <Box>
          <PopularDomainsSection
            domains={domains}
            screenWidth={screenWidth}
            onRegisterDomain={onRegisterDomain}
          />
        </Box>
      ) : (
        <Box
          sx={{
            height: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontFamily: "Tajawal-Regular",
              fontWeight: 400,
            }}
          >
            {i18next.t("No Domains are Available")}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default Domain;
